var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShareCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30.02 30.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2,.cls-3{fill:none;}.cls-3{stroke:#2c3149;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.12,13l-5.99,5.98c-2.18,2.18-2.18,5.72,0,7.9,2.18,2.18,5.72,2.18,7.9,0l5.98-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.08,16.83l5.8-5.8c2.18-2.18,2.18-5.72,0-7.9-2.18-2.18-5.72-2.18-7.9,0l-5.8,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.57,18.44l6.87-6.87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareCopy);
export default __webpack_public_path__ + "static/media/icon-share-copy.533060a25c34a4d0c310c76105f8fce4.svg";
export { ForwardRef as ReactComponent };